/**
 * Shared family-feed vocabulary (Fase 5).
 *
 * The family feed materialises several kinds of celebratory moment as rows in
 * `feed_items` (push model — bus subscribers write the rows, see
 * apps/api/src/services/feed.subscribers.ts), and lets every family member
 * stamp ONE reaction per item from a fixed emoji set (toggle on/off).
 *
 * Shared so apps/api (schema enum + service Zod) and apps/web (FeedCard render
 * switch + reaction bar) cannot drift on the kind enum or the emoji set.
 *
 * `FEED_REACTIONS` is the fixed v1 set — high-five first (the signature
 * gesture), then heart / clap / party / star. One reaction per member per
 * item: tapping a different emoji replaces; tapping the active one clears.
 * Adding an emoji is a v2 change so the reaction bar stays stable in v1.
 */
export const FEED_ITEM_KINDS = [
  'chore_approved',
  'achievement_unlocked',
  'streak_milestone',
  'proposal_approved',
  'meal_planned',
] as const;
export type FeedItemKind = (typeof FEED_ITEM_KINDS)[number];

export const FEED_REACTIONS = ['🙌', '❤️', '👏', '🎉', '⭐'] as const;
export type FeedReaction = (typeof FEED_REACTIONS)[number];

/** Streak lengths (days) that earn a feed celebration — rare by design. */
export const STREAK_MILESTONES = [7, 14, 30, 50, 100, 200, 365] as const;
